import React from 'react'

// css
import 'assets/style/elements/image.scss'

function Element({
  className,
  alt = '',
  src = '',
  width = null,
  height = null,
  imgStyle = {},
  cTTL = false,
  watermarkYn = false,
}) {
  const noImage =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAkAAAAGwAgMAAAA8jjIhAAAACVBMVEX39/fc3Nzr6+tPHTgsAAACxklEQVR42u3bMY6bQBjFcbBEYfdzBIrsKWjSO9EMIh11TkETKRdASrlllFPGMwwD2ERK970o/19hWdvsE37DfMx6qwoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgHNvv079NAvkwilvlecS/kAu0EQgAv1toPvZjxsCEYhABPq/A13m599vHKgNYZAKNL/MP7aB6riZdkKBmhhoEArkXodo20Bz+PrhqUS2gWKYp4VvGugSP6722GrTQHVc+VepQGNVpReRQOni1GVP+6ERqGyydS8QaNoFalKZhK6QS2+EAi33bJ1VVi8bv8J9aMwVShu/8Z16WLu8nF/dzfeyPgaZcoW+xRJZ7/bjLe/2dejr+FZgHupzhYYqlkhmYnSPbrv0I/OZeswVmh5hvPVTRzkxq+MnF0tk/1zmS4Vivs76yTWE91KhtJ1ZP9vfvlelQvE6eZHDhnpZ/I8SiQRq8uIP4aNGIJcXv1M5p15jNPaB3nYVWoYi40DztKtQulPaBlpeXXk2c9aBrulOvaVorAO1cQYqFUolsg00LzPQ8LLe7PayNKeNuzuSaaBrOkHbXxXz8eNTCLsKCRwLd3H7GlQCPSqUtq9RJdA1DdGHhWUbqF0G/V2FzB8Uu3jnGVQCXdJTq9vPIdbnQ8uJkFcJ1KZrUx/O8k0DzctJzOEPQpaBPudL447jvl2gL+Wp1WsECvnKHEpkG6hbZ6BOJFCZge4agXwJ4TUC3bdBWiNQtw3SnUSg3SB9Vwi0L44XGWFfS9SonH50WoG2EsmcoHmtQFuJVL5hVUqkEqiUSCVQKZFKoFIimW/prSWSCbSWSCZQUwZskUBriXS+6ZlLpBMol6jhnwQI9M8GquQCzed5eqs81e38H97eKwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAzv0GfXuBvNlOjbcAAAAASUVORK5CYII='
  if (width !== null || height !== null) {
    imgStyle = {
      width: width !== null ? width : '100%',
      height: height !== null ? height : '100%',
    }
  }

  return (
    <>
      {src ? (
        <img
          src={
            !watermarkYn
              ? `${src}${
                  cTTL ? (src.includes('?') ? '' : '?SP=1') + '&cTTL=' + process.env.REACT_APP_MENU_IMAGE_CTTL : ''
                }`
              : src
          }
          alt={alt}
          className={className}
          style={imgStyle}
          onError={(e) => {
            e.target.src = noImage
            e.target.style.border = '1px solid #dbdbdb'
          }}
        />
      ) : (
        <img src={noImage} className={className} alt="noImage" style={{ ...imgStyle, border: '1px solid #dbdbdb' }} />
      )}
    </>
  )
}

export default Element
